<script lang="ts">
  export let altMessage: string = "";
  export let title: string;
  export let message: string;
  export let visible: boolean = true;
  export let customClass: string = "";
  export let icon: string = "/graphics/sad-folder.svg";
</script>

<div class={!visible ? `hidden ${customClass}` : customClass}>
  <div class="flex justify-center items-center">
    <img
      alt={altMessage}
      width={100}
      class="py-3 m-5 mx-auto"
      src={icon}
    />
  </div>
  <div class="text-center text-[#181818]">
    {#if title !== ""}
      <h1 class="pb-3 text-[24px]">{title}</h1>
    {/if}
    <p class="text-[17px]">{message}</p>
  </div>
</div>
